import { render, staticRenderFns } from "./today-recommend.vue?vue&type=template&id=d6b642e2&lang=pug&"
import script from "./today-recommend.vue?vue&type=script&lang=js&"
export * from "./today-recommend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports